import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ApplicationInstructions from "../../../Components/ApplicationInstructions";
import { Tab, Tabs } from "react-bootstrap";
import { getCurrentUser } from "../../../Services/authService";
import { getLoggedUserDetails, loadUserDetails } from "../../store/auth";
import { useDispatch, useSelector } from "react-redux";
import { getPermission } from "../../store/tools";

export default function EnrollmentSteps() {

    const [instructionShowHide, setInstructionShowHide] = useState(false);
    const [appStatus, setAppStatus] = useState(false);
    const [appApproved, setAppApproved] = useState(false);
    const [rolePermission, setRolePermission] = useState([]);

    const location = useLocation();
    const appType = location?.pathname;
    const usrType = localStorage.getItem("userType");

    const dispatch = useDispatch();
    const currentUser = getCurrentUser();
    const userDetailsSelector = useSelector(getLoggedUserDetails);
    const appPermissionDataSel = useSelector(getPermission);

    useEffect(() => {
        let usrId = currentUser.id;
        if (currentUser.linkUser)
            usrId = currentUser.linkUser;
        if (!userDetailsSelector)
            dispatch(loadUserDetails(usrId));
    }, []);

    useEffect(() => {
        if (userDetailsSelector) {
            setAppStatus(userDetailsSelector?.appSubmit);
            setAppApproved(userDetailsSelector?.approved > 0);
        }
    }, [userDetailsSelector])

    useEffect(() => {
        if (appPermissionDataSel.length > 0) {
            setRolePermission(appPermissionDataSel);
        }
    }, [appPermissionDataSel]);

    const handleInstructionShowHide = () => {
        setInstructionShowHide(!instructionShowHide);
    }

    const navigate = useNavigate();

    const handleSelect = (key) => {
        navigate(key);
    };

    const checkMenuPermission = (mid) => {
        // const { rolePermission } = this.state;
        if (!rolePermission) return;
        if (currentUser?.type === "admin" || !currentUser.linkUser) return true;
        const mm = mid.split("_");
        let chk = false;
        if (mm[0] === "m") {
            const mR = rolePermission.filter(
                (x) => x.id === parseInt(mm[1]) && x.isChecked === true
            );

            if (mR.length > 0) {
                chk = true;
            } else {
                rolePermission
                    .filter((x) => x.id === parseInt(mm[1]))
                    .map((menu) => {
                        const sMenu = menu.menus.filter((x) => x.isChecked === true);
                        if (sMenu.length > 0) {
                            chk = true;
                        } else {
                            menu.menus.map((ssmenu) => {
                                if (ssmenu?.menus) {
                                    const ssMenu = ssmenu.menus.filter(
                                        (x) => x.isChecked === true
                                    );
                                    if (ssMenu.length > 0) {
                                        chk = true;
                                    }
                                }
                            });
                        }
                    });
            }
        }
        if (mm[0] === "sm") {
            rolePermission
                .filter((x) => x.id === parseInt(mm[2]))
                .map((menu) => {
                    const sMenu = menu.menus.filter(
                        (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                    );

                    if (sMenu.length > 0) {
                        chk = true;
                    }
                    // else {
                    //   menu.menus.map((smenu) => {
                    //     if (smenu?.menus) {
                    //       const ssMenu = smenu.menus.filter((x) => x.isChecked === true);
                    //       if (ssMenu.length > 0) {
                    //         chk = true;
                    //       }
                    //     } else {
                    //       if (smenu?.isChecked) {
                    //         chk = true;
                    //       }
                    //     }
                    //   });
                    // }
                });
        }
        if (mm[0] === "ssm") {
            rolePermission
                .filter((x) => x.id === parseInt(mm[3]))
                .map((menu) =>
                    menu.menus
                        .filter((x) => x.id === parseInt(mm[2]))
                        .map((ssmenu) => {
                            if (ssmenu?.menus) {
                                const ssMenu = ssmenu.menus.filter(
                                    (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                                );
                                if (ssMenu.length > 0) {
                                    chk = true;
                                }
                            } else {
                                if (ssmenu?.isChecked) chk = true;
                            }
                        })
                );
        }
        if (mm[0] === "sssm") {
            rolePermission
                .filter((x) => x.id === parseInt(mm[4]))
                .forEach((menu) => {
                    menu.menus
                        .filter((x) => x.id === parseInt(mm[3]))
                        .forEach((ssmenu) => {
                            ssmenu.menus
                                .filter((x) => x.id === parseInt(mm[2]))
                                .forEach((sssmenu) => {
                                    if (sssmenu?.menus) {
                                        const ssMenu = sssmenu.menus.filter(
                                            (x) => x.id === parseInt(mm[1]) && x.isChecked === true
                                        );
                                        if (ssMenu.length > 0) {
                                            chk = true;
                                        }
                                    } else {
                                        if (sssmenu?.isChecked) chk = true;
                                    }
                                });
                        });
                });
        }

        return chk;
    };

    const allPaths = ["/Onboarding", "/ContractDocs", "/AchInfo", "/InsuranceInfo", "/OnboardingStatus", "/DynamicForm", "/PartnerCandidates", "/PartnerInvoices", "/CustomReport"];

    if (allPaths.indexOf(appType) > -1) {
        return <React.Fragment>
            <div className="mt-2">
                <button
                    type="button"
                    style={{
                        cursor: "pointer",
                        color: "blue",
                        fontSize: "14px",
                        background: "none",
                        border: "none",
                        padding: 0,
                        textAlign: "left"
                    }}
                    onClick={handleInstructionShowHide}
                >
                    <i
                        className="fa fa-hand-o-right text-black"
                    ></i>{" "}
                    Instructions for completing onboarding process
                </button>
            </div>
            <div className="mt-0">
                <Tabs
                    id="enrollment-tabs"
                    activeKey={appType === "/DynamicForm" ? "/Onboarding" : appType}
                    onSelect={handleSelect}
                    className="mb--2 p-2 border"
                >
                    {checkMenuPermission("sm_1_2") && <Tab eventKey="/Onboarding" title={<>Onboarding Form {appStatus ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {checkMenuPermission("ssm_1_1_2") && <Tab eventKey="/ContractDocs" title={<>Contract Documents {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {checkMenuPermission("sssm_1_1_1_2") && <Tab eventKey="/AchInfo" title={<>ACH {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {checkMenuPermission("sssm_2_1_1_2") && <Tab eventKey="/InsuranceInfo" title={<>Insurance {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {checkMenuPermission("ssm_2_1_2") && <Tab eventKey="/OnboardingStatus" title={<>Check Onboarding Status {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {checkMenuPermission("ssm_1_2_2") && <Tab eventKey="/PartnerCandidates" title={<>List of Candidates {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {checkMenuPermission("ssm_1_3_2") && <Tab eventKey="/PartnerInvoices" title={<>Invoices and Payments {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                    {<Tab eventKey="/CustomReport" title={<>Reports {appApproved ? <i className="fa fa-solid fa-check text-success ml-1"></i> : <i className="fa fa-solid fa-times text-warning ml-1"></i>}</>} />}
                </Tabs>
            </div>
            {/* <div className="p-3 border mt-1">
                <Link
                    to="/Onboarding"
                    className={
                        (appType === "/Onboarding" || appType === "/DynamicForm")
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Onboarding Form
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                <Link
                    to="/ContractDocs"
                    className={
                        appType === "/ContractDocs"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Contract Documents
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                <Link
                    to="/AchInfo"
                    className={
                        appType === "/AchInfo"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    ACH Information
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>
                <Link
                    to="/InsuranceInfo"
                    className={
                        appType === "/InsuranceInfo"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Insurance Information
                    <i
                        className="fa fa-angle-double-right mr-1 ml-1"
                    ></i>
                </Link>

                <Link
                    to="/OnboardingStatus"
                    className={
                        appType === "/OnboardingStatus"
                            ? "font-weight-bold"
                            : "text-dark"
                    }
                >
                    Enrollment Status

                </Link>

            </div> */}
            {instructionShowHide &&
                <ApplicationInstructions
                    instructionShowHide={instructionShowHide}
                    handleInstructionShowHide={handleInstructionShowHide}
                    entityType={""}
                ></ApplicationInstructions>}
        </React.Fragment>
    }

    return "";

}